var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h1',{attrs:{"contenteditable":"true"}},[_vm._v("沁心笛音智能互动教学辅助平台")])])
}]

export { render, staticRenderFns }